import React from "react";
import { Box, Grid } from "@mui/material";
import {
  BadgeOutlined,
  CategoryOutlined,
  CalendarMonthOutlined,
  InfoOutlined,
  Person,
  EmailOutlined,
  PhoneOutlined,
  ManageAccountsOutlined,
  DirectionsCarFilledOutlined,
  TextSnippetOutlined,
} from "@mui/icons-material";

import { useContractorDetailContext } from "contexts/ContractorDetailContext";
import InformationTile from "components/Shared/InformationTile";
import InfoGridSkeleton from "components/Shared/Skeleton/InfoGridSkeleton";

import Status from "components/Shared/Status";
import { localizeDateShort } from "utils/dateFormats";

const ContractorBasicDetail = () => {
  const { contractorDetail, loadingContractor } = useContractorDetailContext();

  return !loadingContractor ? (
    <Box padding={3}>
      <Grid container spacing={4}>
        <Grid item xs={3}>
          <InformationTile
            icon={() => <BadgeOutlined color="primary" />}
            title="Contractor ID"
            subtitle={contractorDetail?.contractorId}
          />
        </Grid>

        <Grid item xs={3}>
          <InformationTile
            icon={() => <Person color="primary" />}
            title="Name"
            subtitle={contractorDetail?.name}
          />
        </Grid>
        <Grid item xs={3}>
          <InformationTile
            icon={() => <EmailOutlined color="primary" />}
            title="Email"
            subtitle={contractorDetail?.email}
          />
        </Grid>
        <Grid item xs={3}>
          <InformationTile
            icon={() => <PhoneOutlined color="primary" />}
            title="Phone"
            subtitle={contractorDetail?.phone}
          />
        </Grid>
        <Grid item xs={3}>
          <InformationTile
            icon={() => <PhoneOutlined color="primary" />}
            title="Contractor Name"
            subtitle={contractorDetail?.contractorUser?.name}
          />
        </Grid>

        <Grid item xs={3}>
          <InformationTile
            icon={() => <CategoryOutlined color="primary" />}
            title="Category"
            subtitle={contractorDetail?.category}
          />
        </Grid>

        <Grid item xs={3}>
          <InformationTile
            icon={() => <CalendarMonthOutlined color="primary" />}
            title="Start Date"
            subtitle={localizeDateShort(contractorDetail?.startDate)}
          />
        </Grid>

        <Grid item xs={3}>
          <InformationTile
            icon={() => <CalendarMonthOutlined color="primary" />}
            title="End Date"
            subtitle={localizeDateShort(contractorDetail?.endDate)}
          />
        </Grid>
        <Grid item xs={3}>
          <InformationTile
            icon={() => <ManageAccountsOutlined color="primary" />}
            title="Driver"
            subtitle={contractorDetail?.driverId
              ?.map((el) => el?.name)
              ?.join(", ")}
          />
        </Grid>

        <Grid item xs={3}>
          <InformationTile
            icon={() => <DirectionsCarFilledOutlined color="primary" />}
            title="Assigned Vehicles"
            subtitle={contractorDetail?.vehicle_id
              ?.map((el) => el?.vehicle_id)
              ?.join(", ")}
          />
        </Grid>
        <Grid item xs={3}>
          <InformationTile
            icon={() => <TextSnippetOutlined color="primary" />}
            title="T&C"
            subtitle={contractorDetail?.terms_and_conditions}
          />
        </Grid>

        <Grid item xs={3}>
          <InformationTile
            icon={() => <InfoOutlined color="primary" />}
            title="Status"
          >
            <Status isActive={contractorDetail?.isActive} />
          </InformationTile>
        </Grid>
      </Grid>
    </Box>
  ) : (
    <InfoGridSkeleton />
  );
};

export default ContractorBasicDetail;
